export const SWAP_IMPACT_WARNING_THRESHOLD = -5
export const MAX_SLIPPAGE_WARNING_THRESHOLD = 5
// Delay before enabling the confirm button in the swap confirmation modal
export const CONFIRM_BUTTON_ENABLE_DELAY_MS = 1500
